export const CHANGE_PASSWORD_INITIAL_VALUES = {
  newPassword: '',
  confirmPassword: '',
};

export const CHANGE_PASSWORD_QUERY_KEY = ['change password'] as const;
